import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AiPromptService } from './ai-prompt.service';

@Injectable({ providedIn: 'root' })
export class AiElearnioLoaderService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  private cancelSubject = new Subject<void>();
  cancel$ = this.cancelSubject.asObservable();

  constructor(private aiPromptService: AiPromptService) {}

  show(): void {
    this.loadingSubject.next(true);
  }

  hide(): void {
    this.loadingSubject.next(false);
  }

  cancel() {
    this.hide();
    this.cancelSubject.next();
    this.aiPromptService.cancel();
  }
}
